/**
 * Auth API Calls
 * CCH Care - Version 1.0
 */

import client from './client';

/**
 * Login — Step 1: Email + password
 * Returns either { requires_2fa } or { requires_2fa_setup }
 */
export async function login(email, password) {
  const response = await client.post('/auth/login.php', { email, password });
  return response.data;
}

/**
 * Verify 2FA — Step 2: TOTP code
 * Returns session token + user data
 */
export async function verify2FA(tempToken, code) {
  const response = await client.post('/auth/verify-2fa.php', { 
    temp_token: tempToken, 
    code 
  });
  return response.data;
}

/**
 * Validate session — called on app load and route changes
 */
export async function validateSession() {
  const response = await client.get('/auth/session.php');
  return response.data;
}

/**
 * Logout
 */
export async function logout() {
  try {
    await client.post('/auth/logout.php');
  } catch (e) {
    // Logout should always succeed client-side even if API call fails
  }
}

/**
 * Register new organization (self-service trial)
 */
export async function register(data) {
  const response = await client.post('/auth/register.php', data);
  return response.data;
}

/**
 * Get trial status
 */
export async function getTrialStatus() {
  const response = await client.get('/auth/trial-status.php');
  return response.data;
}

/**
 * Request full activation
 */
export async function requestActivation(planRequested, notes) {
  const response = await client.post('/auth/request-activation.php', {
    plan_requested: planRequested,
    notes
  });
  return response.data;
}
